import { NextSeo } from 'next-seo';

//screens
import { Calendar } from '@/screens/ThankYou/Calendar';

export default function Main() {
  return (
    <>
      <NextSeo nofollow={true} noindex={true} title="Thank You | Loadsmart" />

      <Calendar />
    </>
  );
}
